<h2 mat-dialog-title class="dialog_title">
    <span>
        {{ "Edditing a start at" | translate }}:
    </span>
    <button mat-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography" dirEnter (dirSubmit)="!form.valid ? null : onSubmit()">
    <div class="container form_wrapper">
        <form [formGroup]="form">
             <mat-form-field class="full_width_form">
                <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" formControlName="start_at">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #picker [showSpinners]="true" [touchUi]="false" [color]="'primary'">

                  <ng-template>
                    <!-- <mat-icon>star</mat-icon> -->
                    <span>OK</span>
                  </ng-template>
                </ngx-mat-datetime-picker>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()">
        {{ "Back" | translate }}
    </button>
    <button class="ml-1" (click)="onSubmit()" mat-raised-button cdkFocusInitial color="primary" [disabled]="!form.valid">
        {{ "Save" | translate }}
    </button>
</mat-dialog-actions>
